import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';

type Props = {
    open: boolean;
    disabled: boolean;
    message?: string;
    onClose: () => void;
    onConfirm: () => void;
};

export const DeleteUserDialog = ({ open, disabled, message, onClose, onConfirm }: Props) => {
    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={ts('warning', 'Warning!')}
            maxWidth="xs"
            actions={
                <Stack direction="row" justifyContent="center" sx={{ width: '100%', gap: '16%' }}>
                    <Button variant="outlined" onClick={onClose} disabled={disabled} sx={{ minWidth: 100 }}>
                        {ts('plt_cancel', 'Cancel')}
                    </Button>
                    <Button variant="contained" color="error" onClick={onConfirm} disabled={disabled} sx={{ minWidth: 100 }}>
                        {ts('plt_ok', 'OK')}
                    </Button>
                </Stack>
            }
        >
            <Typography variant="body2" color={theme.palette.text.secondary}>
                {message ?? ts('type_delete_please', 'Confirm deleting contact by clicking OK button below')}
            </Typography>
        </BaseDialog>
    );
};
